/* Destiny: a branching choose-your-path game. Edit STORY to change the world. */
(function () {
  var STORY = {
    start: { title: 'The Threshold', text: 'You wake on black sand. Above you, a river of stars. Ahead, three roads open through the Duat, and something far off calls your name. You do not remember having one.',
      choices: [
        { t: 'Follow the golden light of the sun barque', to: 'sun' },
        { t: 'Walk toward the great scales in the distance', to: 'scales' },
        { t: 'Step into the shadow where the jackal waits', to: 'shadow' } ] },

    sun: { title: 'The Sun Barque', text: 'A boat of gold drifts over the dark river. Its crew is silent. Behind it, the serpent Apep uncoils, hungry for the light.',
      choices: [
        { t: 'Take the helm and steer it yourself', to: 'sunA', fx: { pw: 2 } },
        { t: 'Hold the serpent back with a song', to: 'sunB', fx: { ma: 1, pw: 1 } } ] },
    sunA: { title: 'The Helm', text: 'The wheel is hot as a forge. The crew kneels. A crown rests on the prow, offered without a word.',
      choices: [
        { t: 'Wear the crown', to: 'end_pharaoh', fx: { pw: 2 } },
        { t: 'Leave the crown and keep the heading', to: 'gate', fx: { ma: 1 } } ] },
    sunB: { title: 'The Song', text: 'Apep recoils from the sound. As it fades, the serpent speaks: it can be bargained with, or bound.',
      choices: [
        { t: 'Bind it for good', to: 'gate', fx: { pw: 1, ma: 1 } },
        { t: 'Bargain, and learn what it knows', to: 'gate', fx: { sh: 2 } } ] },

    scales: { title: 'The Hall of Two Truths', text: 'Forty-two judges sit in a ring. A feather rests on one pan of the scales. They are waiting for your heart.',
      choices: [
        { t: 'Lay your heart on the scale', to: 'scalesA', fx: { ma: 2 } },
        { t: 'Argue your case before the judges', to: 'scalesB', fx: { pw: 1, sh: 1 } } ] },
    scalesA: { title: 'The Weighing', text: 'The pans tremble. The feather and your heart hold level for a long, quiet breath.',
      choices: [
        { t: 'Accept the verdict', to: 'end_judge', fx: { ma: 2 } },
        { t: 'Ask what the feather weighs against', to: 'gate', fx: { ma: 1, sh: 1 } } ] },
    scalesB: { title: 'The Defence', text: 'Your words are sharp and they land. One judge leans forward and smiles. Another reaches for the scales.',
      choices: [
        { t: 'Press your advantage', to: 'gate', fx: { pw: 2 } },
        { t: 'Admit one true fault', to: 'gate', fx: { ma: 2 } } ] },

    shadow: { title: 'The Jackal Road', text: 'Anubis does not speak. He opens a door in the dark. Beyond it, Nephthys keeps the hour between night and morning.',
      choices: [
        { t: 'Go through the door', to: 'shadowA', fx: { sh: 2 } },
        { t: 'Ask Anubis to walk with you', to: 'shadowB', fx: { ma: 1, sh: 1 } } ] },
    shadowA: { title: 'The Hour Between', text: 'Time folds here. You see a version of yourself already crowned, and another already forgotten.',
      choices: [
        { t: 'Reach for the crowned one', to: 'gate', fx: { pw: 2 } },
        { t: 'Reach for the forgotten one', to: 'end_anubis', fx: { sh: 2 } } ] },
    shadowB: { title: 'The Guide', text: 'Anubis leads you through chambers of embalmed light. At the last door he stops and offers you his staff.',
      choices: [
        { t: 'Take it', to: 'end_anubis', fx: { sh: 2, pw: 1 } },
        { t: 'Refuse it and walk on alone', to: 'gate', fx: { ma: 1 } } ] },

    gate: { title: 'The Last Gate', text: 'All roads meet at one door of black stone. It reads you before you speak.',
      auto: function (s) {
        var hi = Math.max(s.ma, s.pw, s.sh);
        if (hi < 3) return 'end_lost';
        if (s.ma === s.pw || s.ma === s.sh || s.pw === s.sh) return 'end_balance';
        return s.ma === hi ? 'end_judge' : s.pw === hi ? 'end_pharaoh' : 'end_anubis'; } },

    end_pharaoh: { end: true, title: 'Destiny: The Sun King', text: 'You rise as ruler of a horizon that did not exist until you named it. Your name is cut into gold, and the gold does not tarnish.' },
    end_judge: { end: true, title: 'Destiny: The Keeper of Truth', text: 'Your heart is lighter than the feather. You take a seat among the judges and hold the scales for those who come after.' },
    end_anubis: { end: true, title: 'Destiny: The Guardian of the Dark', text: 'You become the one who walks others through the night. Nothing passes that you have not weighed and known.' },
    end_balance: { end: true, title: 'Destiny: The Unknown Deity', text: 'You are neither sun, scale nor shadow, but all three at once. The old kingdom has no name for you yet. You will be the one to give it.' },
    end_lost: { end: true, title: 'Destiny: The Wanderer', text: 'The gate stays closed. But the road remembers you, and the next time you wake on black sand, you will know the way a little better.' }
  };
  var NAMES = { ma: "Ma'at", pw: 'Power', sh: 'Shadow' };

  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text) e.textContent = text; return e; }

  function init(root) {
    var s, trail;
    function reset() { s = { ma: 0, pw: 0, sh: 0 }; trail = []; show('start'); }
    function show(id) {
      var node = STORY[id];
      if (node.auto) { return show(node.auto(s)); }
      root.textContent = '';
      var stats = el('div', 'd-stats');
      Object.keys(NAMES).forEach(function (k) { var sp = el('span', '', NAMES[k] + ' '); sp.appendChild(el('b', '', String(s[k]))); stats.appendChild(sp); });
      root.appendChild(stats);
      root.appendChild(el('h3', 'd-title', node.title));
      var p = el('p', 'd-text', node.text); p.setAttribute('aria-live', 'polite'); root.appendChild(p);
      var box = el('div', 'd-choices');
      if (node.end) {
        var url = root.getAttribute('data-reward-url'), label = root.getAttribute('data-reward-label') || 'Claim your relic';
        var a = el('a', 'btn', label); a.href = url; box.appendChild(a);
        var b = el('button', 'btn ghost', 'Choose another destiny'); b.type = 'button'; b.onclick = reset; box.appendChild(b);
      } else {
        node.choices.forEach(function (c) {
          var b = el('button', '', c.t); b.type = 'button';
          b.onclick = function () {
            if (c.fx) Object.keys(c.fx).forEach(function (k) { s[k] += c.fx[k]; });
            trail.push(node.title); show(c.to);
          };
          box.appendChild(b);
        });
      }
      root.appendChild(box);
      if (trail.length) root.appendChild(el('p', 'd-trail muted', 'Your path: ' + trail.join(', ')));
      var f = root.querySelector('button, a.btn'); if (f && trail.length) f.focus({ preventScroll: true });
    }
    reset();
  }
  function boot() { document.querySelectorAll('[data-destiny]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
